'use client';

import Script from 'next/script';

import { IS_PROD_ENVIRONMENT } from '@/config/app.config';

const IntercomScript = () => {
  const API_BASE = 'https://api-iam.intercom.io';
  const APP_ID = 'oai7bdqq';

  if (!IS_PROD_ENVIRONMENT) {
    return null;
  }

  return (
    <Script id="intercom-script" strategy="afterInteractive">
      {`
        window.intercomSettings = {
            api_base: "${API_BASE}",
            app_id: "${APP_ID}",
            app: "studio",
        };
        (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/' + "${APP_ID}";var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s, x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
        window.Intercom("boot", {}, { app: "studio" });
      `}
    </Script>
  );
};

export default IntercomScript;
